import { Observable, from, of } from "rxjs";
import { delay, concatMap, map, catchError } from "rxjs/operators";
import { ofType } from "redux-observable";
import { ajax, AjaxResponse, AjaxError } from "./ioc";
import { ErrorResponse } from "../utils";
import {
  RequestAction,
  ResponseAction,
  ErrorAction,
  error,
  response,
  IO_REQUEST
} from "./state/actions";

/*
const makeRequest = (request: RequestAction): Observable<AjaxResponse<{}>> => {
  let p;
  if (request.method === "POST") {
    p = ajax.post<Response>(request.url, request.data);
  } else if (request.method === "DELETE") {
    p = ajax.delete(request.url);
  } else {
    p = ajax.get<Response>(request.url);
  }
  return from(p).pipe(
    retryWhen(errors =>
      errors.pipe(
        mergeMap((e: AjaxError) => {
          if (e.response && e.response.status == 504) {
            // TODO - calling defer(()=>makeRequest(...)) will removes
            // uncaught promise exception, but then breaks the retries
            return timer(1500).pipe(
              switchMap(() => defer(() => makeRequest(request)))
            );
          } else {
            return throwError(e);
          }
        })
      )
    )
  );
};
*/
// TODO - replace ajax with rx-dom
const makeRequest = (request: RequestAction) => {
  let inner;
  return from(
    new Promise((resolve, reject) => {
      (function _fire(r: RequestAction) {
        if (r.method === "POST") {
          inner = ajax.post<Response>(r.url, r.data);
        } else if (r.method === "DELETE") {
          inner = ajax.delete(r.url);
        } else {
          inner = ajax.get<Response>(r.url);
        }
        inner
          .then((r: AjaxResponse<{}>) => resolve(r))
          .catch((e: AjaxError) => {
            if (e.response && e.response.status == 504) {
              setTimeout(() => _fire(r), 500);
            } else {
              reject(e);
            }
          });
      })(request);
    })
  );
};

// request epic
export const requestEpic = <Request, Response>(
  action$: Observable<RequestAction<Request>>
): Observable<
  ResponseAction<Response> | ResponseAction<ErrorResponse> | ErrorAction
> =>
  action$.pipe(
    ofType(IO_REQUEST),
    concatMap((request: RequestAction<Request>) => {
      let p = makeRequest(request);
      return p.pipe(
        map((action: AjaxResponse<Response>) =>
          response<Response>(action.data, request)
        ),
        catchError(e => of(error(e, request))),
        delay(300)
      );
    })
  );

export default requestEpic;
